import type { ITeamMemberRoleIcon } from './helpers';

export const TeamMemberRoleIcon = ({ text, ...rest }: ITeamMemberRoleIcon) => {
	const width = text ? Math.ceil(text.length * 5.5 + 26) : 63;

	return (
		<svg
			width={width}
			height='18'
			viewBox={`0 0 ${width} 18`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				x='0.170455'
				y='0.170455'
				width={width - 0.62}
				height='17.3864'
				rx='8.69318'
				fill='#FFF1FF'
			/>
			<rect
				x='0.170455'
				y='0.170455'
				width={width - 0.62}
				height='17.3864'
				rx='8.69318'
				stroke='#EECAEE'
				strokeWidth='0.340909'
			/>
			<circle
				cx='6.81792'
				cy='8.86577'
				r='2.04545'
				fill='#C353A4'
			/>
			{text ? (
				<text
					x='13'
					y='9'
					dominantBaseline='central'
					fontFamily='inherit'
					fontSize='9'
					fontWeight='500'
					fill='#970F71'
					className='text-path'
				>
					{text}
				</text>
			) : (
				<path
					d='M15.7569 4.56328C17.8569 4.56328 19.3469 5.95328 19.3469 7.91328C19.3469 9.93328 17.8569 11.3633 15.7569 11.3633H13.3669V4.56328H15.7569ZM15.7569 10.6333C17.3769 10.6333 18.5369 9.50328 18.5369 7.91328C18.5369 6.39328 17.3769 5.29328 15.7569 5.29328H14.1569V10.6333H15.7569ZM22.37 6.60328C23.86 6.60328 24.79 7.75328 24.64 9.27328H20.76C20.85 10.1333 21.44 10.8033 22.41 10.8033C23 10.8033 23.45 10.5933 23.65 10.2033H24.5C24.21 11.0033 23.41 11.4833 22.41 11.4833C20.98 11.4833 19.99 10.4133 19.99 9.04328C19.99 7.67328 20.97 6.60328 22.37 6.60328ZM22.37 7.26328C21.45 7.26328 20.88 7.91328 20.77 8.73328H23.88C23.84 7.81328 23.25 7.26328 22.37 7.26328ZM29.0396 6.72328H29.8496L27.6596 11.3633H26.9596L24.7696 6.72328H25.5796L27.3096 10.4033L29.0396 6.72328ZM32.3121 6.60328C33.8021 6.60328 34.7321 7.75328 34.5821 9.27328H30.7021C30.7921 10.1333 31.3821 10.8033 32.3521 10.8033C32.9421 10.8033 33.3921 10.5933 33.5921 10.2033H34.4421C34.1521 11.0033 33.3521 11.4833 32.3521 11.4833C30.9221 11.4833 29.9321 10.4133 29.9321 9.04328C29.9321 7.67328 30.9121 6.60328 32.3121 6.60328ZM32.3121 7.26328C31.3921 7.26328 30.8221 7.91328 30.7121 8.73328H33.8221C33.7821 7.81328 33.1921 7.26328 32.3121 7.26328ZM35.5534 4.26328H36.3134V11.3633H35.5534V4.26328ZM39.7467 6.60328C41.1567 6.60328 42.2067 7.64328 42.2067 9.04328C42.2067 10.4433 41.1567 11.4833 39.7467 11.4833C38.3267 11.4833 37.2767 10.4433 37.2767 9.04328C37.2767 7.64328 38.3267 6.60328 39.7467 6.60328ZM39.7467 10.7833C40.7167 10.7833 41.4367 10.0433 41.4367 9.04328C41.4367 8.04328 40.7167 7.30328 39.7467 7.30328C38.7667 7.30328 38.0367 8.04328 38.0367 9.04328C38.0367 10.0433 38.7667 10.7833 39.7467 10.7833ZM45.5614 6.61328C46.8914 6.61328 47.9514 7.69328 47.9514 9.04328C47.9514 10.4033 46.8914 11.4733 45.5614 11.4733C44.9014 11.4733 44.3414 11.2533 43.9314 10.8733V13.6833H43.1714V6.72328H43.9314V7.21328C44.3414 6.83328 44.9014 6.61328 45.5614 6.61328ZM45.4614 10.8033C46.4414 10.8033 47.1914 10.0033 47.1914 9.04328C47.1914 8.08328 46.4414 7.28328 45.4614 7.28328C44.8514 7.28328 44.3114 7.53328 43.9314 8.09328V9.99328C44.3114 10.5533 44.8514 10.8033 45.4614 10.8033ZM51.093 6.60328C52.583 6.60328 53.513 7.75328 53.363 9.27328H49.483C49.573 10.1333 50.163 10.8033 51.133 10.8033C51.723 10.8033 52.173 10.5933 52.373 10.2033H53.223C52.933 11.0033 52.133 11.4833 51.133 11.4833C49.703 11.4833 48.713 10.4133 48.713 9.04328C48.713 7.67328 49.693 6.60328 51.093 6.60328ZM51.093 7.26328C50.173 7.26328 49.603 7.91328 49.493 8.73328H52.603C52.563 7.81328 51.973 7.26328 51.093 7.26328ZM55.0454 7.48328C55.4754 6.93328 56.0954 6.61328 56.8354 6.61328V7.33328C56.0754 7.35328 55.4554 7.70328 55.0454 8.34328V11.3633H54.2854V6.72328H55.0454V7.48328Z'
					fill='#970F71'
					className='text-path'
				/>
			)}
		</svg>
	);
};
